



import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useMediaQuery } from '@mui/system'
import BusinessAppointments from '../../Components/BusinessUser/BusinessAppointments/BusinessAppointments'
import BusinessEmployeeList from '../../Components/BusinessUser/BusinessEmployee/BusinessEmployeeList'
import EmployeeRouteAccess from './EmployeeRouteAccess'
import EmployeeSidebar from '../../Container/EmployeeUser/EmployeeSidebar'
import EmployeeAppointments from '../../Components/EmployeeAppointments/EmployeeAppointments'


const EmployeeRoutes = () => {
  const isLargeScreen = useMediaQuery("(min-width:1441px)");

  return (
    <div>
          <div>
      <EmployeeSidebar />
      <div style={{ marginLeft: isLargeScreen ? '250px' : '0', flexGrow: 1, padding: "10px" }}>

      <Routes>
          <Route path="/appointments" element={<EmployeeRouteAccess element={<EmployeeAppointments />} />}/>
          {/* <Route path="/employees" element={<EmployeeRouteAccess element={<BusinessEmployeeList />} />}/> */}
          {/* <Route path="/employees" element={<BusinessRouteAccess element={<EmployeesList/>} />}/> */}
      </Routes>
    </div>
    </div>
    </div>
  )
}

export default EmployeeRoutes